import { BLACK_100, BLACK_200, BLACK_500, BLACK_700, BLACK_800, BLUE_400, BLUE_500, BLUE_600, WHITE } from '../colors';
var switchConfig = {
  size: 'md',
  checked: false,
  disabled: false,
  style: {},
  controlState: 'none',
  config: {
    size: {
      sm: {
        switchSize: 40
      },
      md: {
        switchSize: 50
      },
      lg: {
        switchSize: 60
      }
    },
    controlState: {
      none: {
        trackColor: {
          off: WHITE,
          on: BLUE_500
        },
        thumbColor: {
          off: BLACK_800,
          on: WHITE
        }
      },
      hover: {
        trackColor: {
          off: WHITE,
          on: BLUE_400
        },
        thumbColor: {
          off: BLACK_700,
          on: WHITE
        }
      },
      pressed: {
        trackColor: {
          off: BLACK_200,
          on: BLUE_600
        },
        thumbColor: {
          off: WHITE,
          on: BLACK_100
        }
      },
      disabled: {
        trackColor: {
          off: BLACK_200,
          on: BLACK_500
        },
        thumbColor: {
          off: BLACK_500,
          on: BLACK_200
        }
      }
    }
  }
};
export default {
  light: switchConfig,
  dark: switchConfig,
  white: switchConfig
};